<template>
  <v-text-field
    ref="inner"
    v-bind="mergedAttrs"
    v-on="$listeners"
    :class="mergedClass">
    <!-- eslint-disable-next-line vue/require-v-for-key -->
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"/>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'MankTextField',
  inheritAttrs: false,
  props: {
    /** outlined: panel formları (varsayılan) | solo: auth vb. */
    variant: {
      type: String,
      default: 'outlined',
      validator: (v) => ['outlined', 'solo'].includes(v),
    },
  },
  computed: {
    mergedClass() {
      const c = this.$attrs.class;
      return ['mank-input', c].filter(Boolean);
    },
    mergedAttrs() {
      const a = { ...this.$attrs };
      delete a.class;

      if (this.variant === 'solo') {
        if (a.solo === undefined) a.solo = true;
        a.outlined = false;
        if (a.elevation === undefined) a.elevation = 0;
      } else {
        if (a.outlined === undefined) a.outlined = true;
        a.solo = false;
      }

      if (a.hideDetails === undefined && a['hide-details'] === undefined) {
        const msgs = a.errorMessages;
        const hasErr = msgs && (Array.isArray(msgs) ? msgs.length : String(msgs).length);
        const hasRules = a.rules && a.rules.length;
        const useAuto = (hasErr || hasRules) || this.variant === 'solo';
        a.hideDetails = useAuto ? 'auto' : true;
      }

      return a;
    },
  },
};
</script>
